export default __webpack_public_path__ + "static/media/AQSPEC_Public2.9c6489a4.png";